import { Button, Text } from "@medusajs/ui"
import { useMe } from "../../../hooks/api/users"
import { clearAuthToken } from "../../../lib/client"

/**
 * Persistent "you're impersonating" banner (KAN-137) - the literal answer to
 * the ticket's requirement that an admin acting on behalf of a vendor find
 * it "visibly obvious ... on behalf of whom they are acting." Renders only
 * for an admin-issued session; `impersonation` is `null` for every normal
 * seller login, so this is a no-op most of the time.
 */
export const ImpersonationBanner = () => {
  const { seller, impersonation } = useMe()

  if (!impersonation) {
    return null
  }

  const handleExit = () => {
    // Clears local state directly rather than the normal logout mutation -
    // that's a real API call against a session that may already be dead if
    // an admin ended it via the kill switch, and clearing local storage must
    // always succeed regardless of server-side session state.
    clearAuthToken()

    // The tab was opened via window.open() from admin-panel, so this should
    // succeed; if the browser refuses (e.g. opened some other way), the page
    // just sits on a login screen instead - never stuck.
    window.close()
    window.location.href = "/login"
  }

  return (
    <div className="bg-ui-tag-orange-bg border-ui-tag-orange-border text-ui-tag-orange-text flex items-center justify-center gap-x-3 border-b px-4 py-2">
      <Text size="small" weight="plus">
        Signed in as {seller?.name ?? "this vendor"} by{" "}
        {impersonation.by_user_email}
      </Text>
      <Button
        variant="transparent"
        size="small"
        className="text-ui-tag-orange-text h-auto p-0 underline"
        onClick={handleExit}
      >
        Exit
      </Button>
    </div>
  )
}
